// extracted by mini-css-extract-plugin
module.exports = {"button":"AppDetailsActions_button__cqjxz","menuIcon":"AppDetailsActions_menuIcon__3mUyp","openButton":"AppDetailsActions_openButton__33EBx"};